import SharedMapContainer from './SharedMapContainer';

export default SharedMapContainer;
